import React from 'react';
import { Select } from 'antd';
import styles from './styles.module.scss';

export interface DropdownProps {
  options: any[];
  onChange: (value: any) => void;
  placeholder: string;
  mode: 'tags' | 'multiple' | undefined;
  maxTagCount?: number;
}

const ChoiceDropdown = ({
  options,
  onChange,
  placeholder,
  mode,
  maxTagCount,
}: DropdownProps) => {
  return (
    <Select
      mode={mode}
      className={styles.select}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      popupMatchSelectWidth
      maxTagCount={maxTagCount}
      allowClear={true}
      filterOption={(input, option) =>
        option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    />
  );
};

export default ChoiceDropdown;
